import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyDigitShortcutPipe } from './currency-digit-shortcut.pipe';



@NgModule({
  declarations: [
    CurrencyDigitShortcutPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CurrencyDigitShortcutPipe
  ]
})
export class CurrencyDigitShortcutPipeModule { }
